// extracted by mini-css-extract-plugin
export default {"container":"homepage-mobile-seo-footer-links-MobileSeoFooterLinksContainer__container--1NBr7"};